import { ProductKey } from "src/config/config";
import { getMyServiceList } from "src/service/console";
import {
  applyCheckPromotionCode,
  checkPromotionTrial,
  getCashUserStatus,
  getServiceUnregisterBill,
} from "src/service/pay";

const checkProductAvailable = async ({
  product,
}: {
  product: ProductKey;
}): Promise<boolean> => {
  const checkCashStatus = await getCashUserStatus({
    product: [product],
  });
  if (
    (checkCashStatus && checkCashStatus.status === "WAIT") ||
    (checkCashStatus.serviceUid === "" && checkCashStatus.status === "APPLY") ||
    checkCashStatus.status === "APPROVED"
  ) {
    return true;
  } else {
    const serviceList = await getMyServiceList({ product });
    if (
      serviceList === undefined ||
      serviceList === null ||
      serviceList.length === 0
    ) {
      try {
        const unregisterPay = await getServiceUnregisterBill({
          billType: "PAY",
          product,
        });
        const unregisterPromotion = await getServiceUnregisterBill({
          billType: "PROMOTION",
          product,
        });
        if (unregisterPay.length > 0) return true;
        else if (unregisterPromotion.length > 0) return true;
        else {
          let result = await applyCheckPromotionCode({ product });
          if (result) {
            return true;
          } else {
            result = await checkPromotionTrial({ product });
            return result.status === "IMPOSSIBLE" ||
              result.status === "POSSIBLE" ||
              result.status === "EXIST" ||
              result.status === "T_USED"
              ? false
              : true;
          }
        }
      } catch (err) {
        return false;
      }
    }
  }
  return true;
};

export default checkProductAvailable;
